export interface CalculationResult {
  role: string;
  cost: number;
  employees: number;
  expectedTasks: number;
  tasksPerDay: number;
  maxClicksPerDay: number;
  theoreticalMaxClicksPerDay: number;
  expectedProductivity: number;
  productivity: number;
  valueProduced: number;
  expectedValue: number;
  trueCost: number;
  totalRoleValue: number;
  experience: 'Beginner' | 'Seasoned' | 'Expert';
  isHoursMode: boolean;
  hoursPerDay: number;
  hoursDifference?: number;
  annualHoursDifference?: number;
  isFullTime: boolean;
  workingDaysPerYear: number;
  calculationDate: string;
  ept: number;
  clicksPerTask: number;
  theoreticalProductivityPercentage?: number;
  totalExperiencedLoadsPerDay?: number;
  knownExperiencesMode?: boolean;
  targetEpt?: number;
  dohertyRateActual?: number;
  theoreticalRateActual?: number;
  efficiencyRatioActual?: number;
  dohertyRateTarget?: number;
  theoreticalRateTarget?: number;
  efficiencyRatioTarget?: number;
  linearTimeImpactSecondsPerDay?: number;
  exponentialTimeImpactSecondsPerDay?: number;
  annualLinearImpactHours?: number;
  annualExponentialImpactHours?: number;
  actualTotalExposureSecondsPerDay?: number;
  targetTotalExposureSecondsPerDay?: number;
  wasteTotalSecondsPerDay?: number;
  secondsPerProductiveLoadActual?: number;
  secondsPerProductiveLoadTarget?: number;
  theoreticalProductivityPercentage?: number;
  upsideProgressRemainingPercentage?: number;
}

export const ROLE_DEFAULTS = {
  'Licensed Users - Blended': {
    tasksPerDay: 70,
    clicksPerTask: 30
  },
  'Service Agent': {
    tasksPerDay: 25,
    clicksPerTask: 45
  },
  'Sales Development Rep': {
    tasksPerDay: 15,
    clicksPerTask: 65
  },
  'Account Executive': {
    tasksPerDay: 5,
    clicksPerTask: 90
  }
};